import React from "react";
import { Box } from "@mui/system";
import SearchSelect from "../components/searchAndSelect";
import { Button } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { vendorDetailsClicked } from '../store/gloabalState';
import useNotify from "../utils/useNotify";

export default function VendorsView() {
    const [vendorDetails, setVendorDetails] = useRecoilState(vendorDetailsClicked);
    let navigate = useNavigate();
    let notify = useNotify();

    const selectSearchData = (e) => {
        setVendorDetails(e);
    };

    const editVendor = () => {
        if(vendorDetails.id){
            navigate(`/editvendor/${vendorDetails.id}`)
        }else{
            notify.error("Select Vendor from the list")
        }
    }
    return (
        <Box sx={{ marginBottom: "1rem" }}>
            <Box sx={{ padding: ".5rem", display: "flex" }}>
                <SearchSelect
                    selectSearchData={selectSearchData}
                    label={"Select Vendor"}
                    name={"vendorSelect"}
                />
                <Button
                    onClick={editVendor}
                    variant="contained"
                    sx={{ margin: ".5rem 1rem" }}
                >
                    Edit Vendor
                </Button>
            </Box>
        </Box>
    )
}